export default {
  primary: window.location.hostname === 'colsubsidio.financialomejor.com' ? '#011F5B' : '#27097B',
  secondary: window.location.hostname === 'colsubsidio.financialomejor.com' ? '#FEED00' : '#F4471F',
  accent: '#ef2e19',
  lightGray: '#e3e3e3',
  white: '#ffffff'
};
